import React from "react";
import PolicyLayout, { PolicyH2, PolicyP, PolicyUL, PolicyCallout } from "../components/app/PolicyLayout";

const TOC = [
  { id: "values", label: "1. Our values" },
  { id: "welcome", label: "2. Always welcome" },
  { id: "never", label: "3. Never OK" },
  { id: "mod", label: "4. How we moderate" },
  { id: "report", label: "5. Reporting" },
  { id: "appeal", label: "6. Appeals" },
];

export default function Guidelines() {
  return (
    <PolicyLayout
      title="Campfire Code"
      eyebrow="Community Guidelines"
      lastUpdated="23 April 2026"
      toc={TOC}
      testid="guidelines-page"
    >
      <PolicyCallout>
        <strong>Be kind. Share knowledge. Lift each other up.</strong> That's the whole thing, really. The rest of
        this page is about how we protect that promise.
      </PolicyCallout>

      <PolicyH2 id="values">1. What we stand for</PolicyH2>
      <PolicyP>
        Camping is special because you end up sharing a fire with strangers and leave as friends. CampCompass
        exists to bring that same warmth online. No trolling, no gatekeeping, no "you're doing it wrong". Just
        campers helping campers.
      </PolicyP>

      <PolicyH2 id="welcome">2. You're always welcome here</PolicyH2>
      <PolicyUL>
        <li>If you're a first-time camper asking "silly" questions — welcome.</li>
        <li>If you're a grizzled bothy-veteran with 40 years of wisdom — welcome.</li>
        <li>Solo, family, with a disability, LGBT+, any age, any budget — welcome.</li>
        <li>Short posts, long posts, mobile-typo posts — welcome.</li>
      </PolicyUL>

      <PolicyH2 id="never">3. What's never OK</PolicyH2>
      <PolicyUL>
        <li>Personal attacks, harassment, or hate speech of any kind.</li>
        <li>Gatekeeping (e.g. "that's not real camping").</li>
        <li>Sharing anyone's personal details without consent.</li>
        <li>Spam, affiliate dumping, or fake reviews to boost a site.</li>
        <li>Encouraging unsafe or illegal behaviour (wild-fire camping without permission, trespassing, etc.).</li>
        <li>Hateful speech about campsite owners, staff, or other members — criticism is fine, malice isn't.</li>
      </PolicyUL>

      <PolicyH2 id="mod">4. How moderation works</PolicyH2>
      <PolicyP>
        We use a mix of real human moderators and a "positivity badge" AI filter (Claude 4.5) that flags
        potentially harmful posts for a human to review.
      </PolicyP>
      <PolicyP>
        When we remove a post, we'll always tell you why. When we have to suspend an account, we do so reluctantly
        and with a clear reason — and you'll always get one chance to discuss it with us first (unless the breach
        is serious enough to endanger others).
      </PolicyP>

      <PolicyH2 id="report">5. Reporting something</PolicyH2>
      <PolicyP>
        Every thread, reply, and review has a <strong>Report</strong> button. Use it freely — false reports won't
        hurt you, and we always check context before acting. For anything urgent (threats, child safety), email{" "}
        <a href="mailto:safety@camp-compass.uk" className="link-underline text-[#ff4500]">safety@camp-compass.uk</a>.
      </PolicyP>

      <PolicyH2 id="appeal">6. Appeals</PolicyH2>
      <PolicyP>
        Disagree with a moderation decision? Reply to the email we sent you, or write to{" "}
        <a href="mailto:hello@camp-compass.uk" className="link-underline text-[#ff4500]">hello@camp-compass.uk</a>. We read every appeal, and we're happy to be wrong.
      </PolicyP>
    </PolicyLayout>
  );
}
